var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSliderHandle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 19.1665C13.3333 20.0832 12.5833 20.8332 11.6667 20.8332C10.75 20.8332 10 20.0832 10 19.1665V10.8332C10 9.9165 10.75 9.1665 11.6667 9.1665C12.5833 9.1665 13.3333 9.9165 13.3333 10.8332V19.1665ZM16.6667 19.1665V10.8332C16.6667 9.9165 17.4167 9.1665 18.3333 9.1665C19.25 9.1665 20 9.9165 20 10.8332V19.1665C20 20.0832 19.25 20.8332 18.3333 20.8332C17.4167 20.8332 16.6667 20.0832 16.6667 19.1665Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSliderHandle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slider_handle.61c1098f1c4c165208cbf098be37ce85.svg";